/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  production: true,
  apiDir: 'https://api-testing.solucionesempresariales.com.uy/',
  envName: 'prod'
};
